module.exports = __webpack_public_path__ + "img/Edelstahlhandlauf.c2de392a.webp";